<template>
  <div class="event-text">
    <span v-if="hasInfoText">{{ infoText }}</span>
    <span v-else>
      {{ presentationTypeL }}
      <span v-if="isTitleSession"
        ><em>"{{ titleSession }}" </em></span
      >
      <span v-if="isKeynote">{{ byL }} {{ person(invitee1, awAwch1) }}</span>
      <span v-else>{{ withL }} {{ person(invitee1, awAwch2) }}</span>
      <span v-if="isInvitee2"> {{ andL }} {{ person(invitee2) }}</span
      ><span v-if="isTitleTalk"> {{ aboutL }} <em>"{{ titleTalk }}"</em></span
      >.</span
    >
  </div>
</template>

<script>
export default {
  props: [
    "infoText",
    "presentationType",
    "remoteType",
    "titleEvent",
    "titleSession",
    "titleTalk",
    "invitee1",
    "invitee2",
    "awAwch1",
    "awAwch2",
  ],
  computed: {
    hasInfoText() {
      return this.infoText !== undefined && this.infoText !== "";
    },
    isTitleSession() {
      return this.titleSession !== "";
    },
    isTitleTalk() {
      return this.titleTalk !== "";
    },
    isKeynote() {
      return this.presentationType == "keynote";
    },
    isInvitee2() {
      return this.invitee2 !== "";
    },
    presentationTypeL() {
      if (this.presentationType == "panelist") {
        if (this.$language == "de") {
          return "Paneldiskussion";
        }
        if (this.$language == "en") {
          return "Panel discussion";
        }
        if (this.$language == "fr") {
          return "Discussion de groupe";
        }
        if (this.$language == "it") {
          return "Discussione";
        }
      }
      if (this.presentationType == "keynote") {
        if (this.$language == "de") {
          return "Vortrag";
        }
        if (this.$language == "en") {
          return "Talk";
        }
        if (this.$language == "fr") {
          return "Conférence";
        }
        if (this.$language == "it") {
          return "Conferenza";
        }
      }
      if (this.presentationType == "workshop") {
        if (this.$language == "fr") {
          return "Atelier";
        } else return "Workshop";
      } else return null;
    },
    withL() {
      if (this.$language == "de") {
        return "mit";
      }
      if (this.$language == "en") {
        return "with";
      }
      if (this.$language == "fr") {
        return "avec";
      }
      if (this.$language == "it") {
        return "con";
      } else return "";
    },
    byL() {
      if (this.$language == "de") {
        return "von";
      }
      if (this.$language == "en") {
        return "by";
      }
      if (this.$language == "fr") {
        return "de";
      }
      if (this.$language == "it") {
        return "di";
      } else return "";
    },
    aboutL() {
      if (this.$language == "de") {
        return "über";
      }
      if (this.$language == "en") {
        return "about";
      }
      if (this.$language == "fr") {
        return "sur";
      }
      if (this.$language == "it") {
        return "con";
      } else return "";
    },
    andL() {
      if (this.$language == "de") {
        return "und";
      }
      if (this.$language == "en") {
        return "and";
      }
      if (this.$language == "fr") {
        return "et";
      }
      if (this.$language == "it") {
        return "e";
      } else return "";
    },
  },
  methods: {
    person(invitee, aw) {
      if(aw !== undefined) {
        return invitee + " (" + aw + ") ";
      }
      else return invitee + " "
    },
  },
};
</script>